// [sc-49299] Finestra di stampa del preventivo, condivisa da Nuovo, Modifica
// ed elenco Preventivi. La pagina apre la finestra con i dati del PDF
// (`apriStampa`).
//
// Nuovo e Modifica non hanno ancora salvato: la finestra mostra l'anteprima
// dei dati del form e la pagina ha `salvaDaStampa()`, che salva e restituisce
// i dati del PDF presi dal preventivo salvato (null se il salvataggio non è
// andato: la pagina ha già dato il messaggio). Il PDF si rifà da quei dati
// con i campi scelti. Annulla o la X non fanno niente.
//
// Dopo il caricamento la pagina può fare il suo seguito in
// `dopoStampa(nome, quoteId)`; `nome` è null se il preventivo è stato
// salvato ma il PDF non è stato caricato.
//
// I PDF automatici (dopo un acconto o una modifica di prezzo) non passano di
// qui: usano `caricaPdfPreventivo` con il PDF completo.

import logoPath from "@/assets/barcio-logo.png";
import { nomeFilePreventivo, pdfPreventivo } from "@/utilities/pdfPreventivo";

const CHIUSA = { show: false, dati: null, salvando: false };

export default {
  data() {
    return {
      stampa: { ...CHIUSA },
    };
  },
  methods: {
    apriStampa(dati) {
      this.stampa = { show: true, dati, salvando: false };
    },

    // carica il PDF tra i documenti del preventivo, poi lo scarica
    async caricaPdfPreventivo(doc, quoteId) {
      const nome = nomeFilePreventivo(quoteId);
      // un File col nome giusto: Multer lo vede come originalname
      const file = new File([doc.output("blob")], nome, {
        type: "application/pdf",
      });
      await this.$store.dispatch("uploadQuoteDocument", {
        quoteId,
        document: file,
        filename: nome,
      });
      doc.save(nome);
      return nome;
    },

    async onScaricaStampa({ doc, campi }) {
      if (!this.stampa.dati || this.stampa.salvando) return;
      this.stampa.salvando = true;

      let quoteId = this.stampa.dati.id;
      const salva = typeof this.salvaDaStampa === "function";
      if (salva) {
        const salvati = await this.salvaDaStampa();
        if (!salvati) {
          this.stampa = { ...CHIUSA };
          return;
        }
        doc = pdfPreventivo(salvati, campi, { logo: logoPath });
        quoteId = salvati.id;
      }

      let nome;
      try {
        nome = await this.caricaPdfPreventivo(doc, quoteId);
      } catch (error) {
        console.error("Errore durante l'upload del PDF:", error);
        if (!salva) {
          // la finestra resta aperta: si può riprovare
          this.stampa.salvando = false;
          this.$toast.error(
            error.response?.data?.details ||
              error.response?.data?.error ||
              "Errore durante il caricamento del PDF."
          );
          return;
        }
        // il preventivo è salvato: riprovare lo salverebbe di nuovo
        this.$toast.error(
          "Preventivo salvato, ma il PDF non è stato caricato: rifallo con Rigenera PDF."
        );
        this.stampa = { ...CHIUSA };
        await this.dopoStampa?.(null, quoteId);
        return;
      }
      this.$toast.success("PDF generato e caricato con successo!");
      this.stampa = { ...CHIUSA };
      await this.dopoStampa?.(nome, quoteId);
    },

    onChiudiStampa() {
      this.stampa = { ...CHIUSA };
    },
  },
};
